import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import baseURL from "../../../configs/api";
import { GridColDef } from "@mui/x-data-grid";
import { getCustomersExtraInformationsByCustomerId } from "../../../services/customerExtraInformation";
import { useTheme } from "../../../components/hooks/useTheme";
import axois from "../../../configs/axois";
import styled from "@emotion/styled";
import axios from "axios";
import useAuth from "../../../components/hooks/useAuth";
import { CustomDataGrid } from "../../../components/common/CustomDataGrid";
import PleaseWaitPopup from "../../PleaseWaitPopup";
import colorConfigs from "../../../configs/colorConfigs";
import { CustomImagePopup } from "../../../components/common/CustomImagePopup";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";
import useGeneral from "../../../components/hooks/useGeneral";
import moment from "moment";

const VisuallyHiddenInput = styled('input')`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;

type Props = {
    idNumber: string;
};

export default function CustomerFiles({ idNumber }: Props) {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { themeStyles } = useTheme();
    const { handleTenantError }: any = useTenant();
    const { auth }: any = useAuth();
    const { dateFormat }: any = useGeneral();
    const [fullName, setFullName] = useState<string>("");
    const [tableData, setTableData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [imagePopup, setImagePopup] = useState<boolean>(false);
    const [fileIndex, setFileIndex] = useState<number>(0);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
    const [isFilesRefresh, setIsFileRefresh] = useState<boolean>(true);

    const columns: GridColDef[] = [
        {
            field: "filePath",
            headerClassName: themeStyles.table.headerBg,
            headerName: "File",
            align: "left",
            editable: false,
            sortable: false,
            width: 300,
            renderCell: (params) => {
                return (
                    <span onClick={() => {
                        const index = tableData.indexOf(params.row);
                        setFileIndex(index);
                        setImagePopup(true);
                    }}
                        style={{ color: "var(--app-link-color)" }}
                        className="underline cursor-pointer">
                        {params?.value}
                    </span>
                );
            },
        },
        {
            field: "uploadedBy",
            headerName: "Author",
            headerClassName: themeStyles.table.headerBg,
            editable: false,
            sortable: false,
            align: "left",
            width: 170,

        },
        {
            field: "imageSize",
            headerName: "Size",
            headerClassName: themeStyles.table.headerBg,
            editable: false,
            sortable: false,
            width: 220,
            align: "left",
        },
        {
            field: "uploadedAt",
            headerName: "Date",
            editable: false,
            headerClassName: themeStyles.table.headerBg,
            sortable: false,
            width: 170,
            align: "left"
        },

    ];

    useEffect(() => {
        axois
            .get(`${baseURL}Customer/${idNumber}`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setFullName(response.data.firstName + " " + response.data.lastName);
                handleTenantError(null);
            })
            .catch((error) => {
                handleTenantError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber])

    useEffect(() => {
        if (isFilesRefresh) {
            setLoading(true);
            getCustomersExtraInformationsByCustomerId(parseInt(idNumber), tenantId)
                .then((data) => {
                    setTableData(() =>
                        data?.filter((item: any) => item.filePath !== "").map((item: any) => {
                            return {
                                id: item.id,
                                filePath: item.filePath,
                                uploadedBy: item.uploadedBy,
                                imageSize: (item.imageSize === 0 ? "-" : (item.imageSize / 1024).toFixed(2)) + " KB",
                                uploadedAt: item.uploadedAt
                                    ? moment(new Date(item.uploadedAt)).format(dateFormat + "hh:mm a")
                                    : "",

                            }
                        })
                    );
                    setIsFileRefresh(false);
                    setLoading(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    handleTenantError(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFilesRefresh]);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPleaseWaitPopup(true);
        const selectedFiles = event.target.files as FileList;

        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);

            axios
                .post(`${baseURL}customerFile/upload`, formData, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: true,
                })
                .then(response => {
                    saveFileOnFileUploadApi(response.data, selectedFiles[0].size)
                    handleTenantError(null);
                })
                .catch(error => handleTenantError(error));
        } else {
            setPleaseWaitPopup(false);
        }
    };


    const saveFileOnFileUploadApi = async (fileName: string, fileSize: number) => {
        if (fileName) {
            await axios.post(
                `${baseURL}customerExtraInformation?userId=${auth?.id}`,
                JSON.stringify({
                    idNumber: null,
                    issueDate: null,
                    exprationDate: null,
                    filePath: fileName,
                    idTypeId: 0,
                    customerId: idNumber,
                    imageSize: fileSize,
                    uploadedAt: new Date(),
                    uploadedBy: auth?.givenname
                }),
                {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "application/json"
                    },
                    withCredentials: true,
                }
            )
                .then(() => {
                    setPleaseWaitPopup(false);
                    setIsFileRefresh(true);
                    handleTenantError(null);
                })
                .catch((error) => {
                    handleTenantError(error);
                });
        }
        else {
            setPleaseWaitPopup(false);
        }
    }

    return (
        <>
            <div className="w-full mt-2">
                <div className={`w-full pb-4`}>
                    <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                        <div className="flex items-center gap-1.5">
                            <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Customer - {fullName}</h2>
                        </div>

                        <div className="flex items-center gap-1.5">

                            <Button
                                component="label"
                                variant="contained"
                                htmlFor="file-upload"
                                className={`px-[12px] py-[10px] ${colorConfigs.btn.main.tailwind} shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}

                            >
                                <span className="text-xs font-medium">Upload</span>
                                <VisuallyHiddenInput
                                    id="file-upload"
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                />
                            </Button>
                        </div>
                    </div>
                </div>
                <div className={`w-full border ${themeStyles.main.borderColor} rounded-[16px]`}>
                    <div className={`flex justify-between items-center p-4 border-b ${themeStyles.main.borderColor}`}>
                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Files</h2>
                    </div>

                    <CustomDataGrid
                        filteredRows={tableData}
                        columns={columns}
                        loading={loading}
                    />
                </div>
            </div>

            <CustomImagePopup
                showPopup={imagePopup}
                handlePopup={() => setImagePopup(false)}
                filePath={tableData.map(item => ({
                    fileName: `${baseURL}customerFile/Get?name=${item?.filePath}`
                }))}
                fileIndex={fileIndex}
                setFileIndex={setFileIndex}
                imageBaseUrlPath="customerFile"
            />

            <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
        </>
    );
};